
import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import PageList from "."

export default function HotelAmenities({ exclude, background }) {
  const data = useStaticQuery(graphql`
    {
      wpOption(id: { eq: "cG9zdDo5OA==" }) {
        hotelSpaOptions {
          hotelAmenitiesSection {
            heading
            pages {
              ...PageCard
            }
          }
        }
      } 
      
    }
  `)
  const hotelAmenities = data.wpOption.hotelSpaOptions.hotelAmenitiesSection
  const pages = hotelAmenities.pages.filter((page) => page.uri !== exclude)
  const { heading } = hotelAmenities
  return <PageList props={{ heading, pages, background }} />
}